import layout from './layout';
import message from './message';

export default {
  ...layout,
  ...message
}
